import PagedElements from '@/models/paged/pagedelements';
import PermissionKeyListViewModel from '@/models/view/permissionkeylistviewmodel';

export default class PagedPermissionKeys extends PagedElements<PermissionKeyListViewModel> {
    constructor(init?: Partial<PagedPermissionKeys>) { super(init); }
}